<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Configurações de Dashboard</h2>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'dashboard' }">
              Dashboard
            </router-link>
          </li>
          <li class="active">
            <strong>Configurações de Dashboard</strong>
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Configurações de Dashboard</h5>
            </div>
            <div class="ibox-content">
              <div class="pull-right m-b-xs">
                <div class="btn-filter-group">
                  <a
                    :class="{
                      'btn-white': !showFilters,
                      'btn-danger': showFilters
                    }"
                    class="btn"
                    @click="toggleFilter"
                  >
                    <span v-if="!showFilters">Adicionar Filtros</span>
                    <span v-else>Remover Filtros</span>
                  </a>
                  <router-link
                    :to="{ name: 'config-dashboard-create' }"
                    class="btn btn-primary"
                  >
                    Adicionar novo
                  </router-link>
                </div>
              </div>
              <div class="form-group">
                <label
                  >Itens por página<select
                    :value="pageSize"
                    class="form-control input-sm n-itens"
                    @change="selectPageSize($event.target.value)"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select></label
                >
              </div>
              <div
                v-if="showFilters"
                :class="{ open: showFilters }"
                class="filtros"
              >
                <label>Filtros de Pesquisa</label>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <input
                        v-model="filter.nome"
                        class="form-control"
                        type="text"
                        placeholder="Nome"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        :value="filter.cadeia"
                        endpoint="cadeia/seriehistorica"
                        request-method="POST"
                        filters-in-body
                        placeholder="Selecione uma Cadeia"
                        @select="setCadeia"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        :value="filter.grupo"
                        :disabled="!filter.cadeia"
                        endpoint="indicadorgrupo/seriehistorica"
                        request-method="POST"
                        filters-in-body
                        placeholder="Selecione um Grupo de Ind."
                        label-key="Descricao"
                        :query-filters="grupoSelectFilters"
                        @select="onSelectGrupo"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.indicador"
                        :disabled="!filter.cadeia"
                        endpoint="indicadorfinal/seriehistorica"
                        request-method="POST"
                        filters-in-body
                        label-key="IndicadorNome"
                        placeholder="Selecione um Indicador"
                        :query-filters="indicadorSelectFilters"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.estado"
                        placeholder="Selecione um Estado"
                        endpoint="estado/seriehistorica"
                        request-method="POST"
                        filters-in-body
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.regiao"
                        placeholder="Selecione uma Região"
                        endpoint="regiao/seriehistorica"
                        request-method="POST"
                        filters-in-body
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.cidade"
                        placeholder="Selecione uma Cidade"
                        endpoint="cidade/seriehistorica"
                        request-method="POST"
                        filters-in-body
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.estadoDestino"
                        placeholder="Selecione um Estado Destino"
                        endpoint="estado/seriehistorica"
                        request-method="POST"
                        filters-in-body
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.regiaoDestino"
                        endpoint="regiao/seriehistorica"
                        request-method="POST"
                        filters-in-body
                        placeholder="Selecione uma Região Destino"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.cidadeDestino"
                        endpoint="cidade/seriehistorica"
                        request-method="POST"
                        filters-in-body
                        placeholder="Selecione uma Cidade Destino"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <ResourceSelect
                        v-model="filter.safra"
                        endpoint="safra/seriehistorica"
                        request-method="POST"
                        filters-in-body
                        placeholder="Selecione uma safra"
                        label-key="Descricao"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <DataTable
                :headers="table.headers"
                :data="items"
                :actions="table.actions"
              />
              <Paginate
                :selected="currentPage - 1"
                :page-count="totalPages"
                :click-handler="load"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store'
import sweetalert from '../../lib/sweetalert'
import { DataTable, Paginate } from '../../shared'
import { mapGetters, mapActions } from 'vuex'
import { debounce } from 'lodash'
import ResourceSelect from '../../components/ResourceSelect'
import $ from 'jquery'

export default {
  name: 'ConfigDashboardIndex',
  components: {
    DataTable,
    Paginate,
    ResourceSelect
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch('configDashboard/index/requestData', {
      page: 1,
      pageSize: store.state.configDashboard.index.pageSize
    })
    next()
  },
  created() {
    document.title = 'Configurações de Dashboard - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')

    const filters = this.loadStoredFilters()

    if (filters) {
      this.setFilters(filters)
      return
    }

    this.filter.estado = { Id: 51, Nome: 'Mato Grosso' }
    this.filter.tipoLocalidade = { Id: 1, Descricao: 'Estado' }
  },
  mounted() {
    const loading = document.querySelector('#loading')
    loading.style.display = 'none'
    $('[data-toggle="tooltip"]').tooltip()
  },
  computed: {
    ...mapGetters('configDashboard/index', [
      'pageSize',
      'items',
      'currentPage',
      'totalPages'
    ]),
    grupoSelectFilters() {
      const { cadeia } = this.filter
      const filters = {}

      if (cadeia && cadeia.Id) filters.cadeia = [cadeia.Id]

      return filters
    },
    indicadorSelectFilters() {
      const { cadeia, grupo } = this.filter
      const filters = {}

      if (cadeia && cadeia.Id) filters.cadeia = [cadeia.Id]
      if (grupo && grupo.Id) filters.grupo = [grupo.Id]

      return filters
    }
  },
  methods: {
    setFilters(filters) {
      this.filter = filters
      this.showFilters = true
    },
    loadStoredFilters() {
      const filters = localStorage.getItem('filters.configDashboardExterno')

      return filters ? JSON.parse(filters) : undefined
    },
    saveFilters(filters) {
      localStorage.setItem(
        'filters.configDashboardExterno',
        JSON.stringify(filters)
      )
    },
    setCadeia(value) {
      this.$set(this.filter, 'cadeia', value)
      this.$set(this.filter, 'grupo', undefined)
      this.$set(this.filter, 'indicador', undefined)
    },
    onSelectGrupo(value) {
      this.$set(this.filter, 'grupo', value)
      this.$set(this.filter, 'indicador', undefined)
    },
    edit({ Id }) {
      this.$router.push({ name: 'config-dashboard-edit', params: { id: Id } })
    },
    details({ Id }) {
      this.$router.push({
        name: 'config-dashboard-details',
        params: { id: Id }
      })
    },
    async remove({ Id }) {
      try {
        await sweetalert({
          title: 'Você tem certeza?',
          text: 'O item selecionado será removido.',
          type: 'warning'
        })
        await this.removeItem(Id)
        await this.load()
      } catch (e) {
        // lel
      }
    },
    load: debounce(function(page) {
      if (!page) {
        page = 1
      }

      const pageSize = this.pageSize

      const filter = Object.keys(this.filter).reduce((filters, key) => {
        if (!this.filter[key]) return filters

        const value = this.filter[key].Id || this.filter[key]
        const filterKey = `${capitalizeKey(key)}Id`

        return { ...filters, [filterKey]: value }
      }, {})

      this.requestData({ ...filter, page, pageSize })
    }, 750),
    async selectPageSize(pageSize) {
      await this.setPageSize(pageSize)
      this.load()
    },
    toggleFilter() {
      this.showFilters = !this.showFilters

      this.filter = {
        nome: ''
      }
    },
    ...mapActions('configDashboard/index', [
      'setPageSize',
      'requestData',
      'removeItem'
    ])
  },
  watch: {
    filter: {
      deep: true,
      handler(filter) {
        this.saveFilters(filter)
        this.load()
      }
    }
  },
  data() {
    return {
      showFilters: false,
      filter: {
        nome: ''
      },
      table: {
        headers: [
          { property: 'CadeiaNome', text: 'Cadeia' },
          { property: 'IndicadorGrupoDescricao', text: 'Grupo' },
          { property: 'IndicadorNome', text: 'Indicador' },
          { property: 'EstadoNome', text: 'Estado' },
          { property: 'RegiaoNome', text: 'Região' },
          { property: 'CidadeNome', text: 'Cidade' },
          { property: 'EstadoDestinoNome', text: 'Estado Destino' },
          { property: 'RegiaoDestinoNome', text: 'Região Destino' },
          { property: 'CidadeDestinoNome', text: 'Cidade Destino' },
          { property: 'SafraDescricao', text: 'Safra' }
        ],
        actions: [
          {
            name: 'edit',
            onclick: this.edit,
            class: 'fa-fw fa fa-pencil text-navy',
            title: 'Editar Item',
            component: 'Marca'
          },
          {
            name: 'remove',
            onclick: this.remove,
            class: 'fa-fw fa fa-trash text-danger',
            title: 'Remover Item',
            component: 'Marca'
          }
        ]
      }
    }
  }
}

function capitalizeKey(string) {
  return string.replace(/^./, string[0].toUpperCase())
}
</script>
